import { gql } from 'graphql-request';

const checkout = gql`
  mutation (
    $subdomain: String!
    $branchId: ID!
    $cartId: String!
    $isScheduled: Boolean!
    $expectedAt: String
    $isGift: Boolean
    $timeSlot: String
    $addressId: ID
    $deliveryZone: DeliveryZoneMs
    $carId: ID
    $isWalletUsed: Boolean
    $roundingAmount: Float
    $paymentGatewayId: ID
    $paymentMethodId: ID
    $paymentType: String!
    $paymentOption: String
    $paymentToken: String
    $recipient: RecipientInfo
    $isManualOrder: Boolean
    $operatorId: ID
    $umbrellaNumber: String
    $umbrellaInstructions: String
    $language: Int
  ) {
    checkout(
      subdomain: $subdomain
      branchId: $branchId
      cartId: $cartId
      isScheduled: $isScheduled
      expectedAt: $expectedAt
      isGift: $isGift
      timeSlot: $timeSlot
      addressId: $addressId
      carId: $carId
      isWalletUsed: $isWalletUsed
      roundingAmount: $roundingAmount
      paymentGatewayId: $paymentGatewayId
      paymentMethodId: $paymentMethodId
      paymentType: $paymentType
      paymentOption: $paymentOption
      paymentToken: $paymentToken
      recipient: $recipient
      deliveryZone: $deliveryZone
      isManualOrder: $isManualOrder
      operatorId: $operatorId
      umbrellaNumber: $umbrellaNumber
      umbrellaInstructions: $umbrellaInstructions
      language: $language
    ) {
      orderNumber
      submissionTime
    }
  }
`;

export default checkout;
